import { Pipe, PipeTransform } from '@angular/core';
/**
 * Word pipe, transforms pascal case to word
 */
@Pipe({
  name: 'word'
})
export class WordPipe implements PipeTransform {
  /**
   * transforms given value to word
   * @param value value
   * @param args args
   */
  transform(value: any, args?: any): any {
    return value.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1');
  }
}
